import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

  const setAllowedTabList = (state, { payload }) => {
      state.allowedTabList=[...payload]
  };

  const setTabList = (state, { payload }) => {
    state.tabList=payload
  };

  const setSelectedModulePermission = (state, { payload }) => {
    state.selectedModulePermissions=payload
  };

  const clearAllowedTabList = (state, { payload })  => {
    return {...state, allowedTabList:[] };
  };

  const clearTabList = (state, { payload })  => {
    return {...state, tabList:[] };
  };

  const clearSelectedModulePermission = (state, { payload })  => {
    return {...state, selectedModulePermissions:[] };
  };
const initialState = {
  allowedTabList:[],
  tabList:[],
  selectedModulePermissions:[],
};

export default createReducer(initialState, {
  [TYPES.SET_TAB_LIST]: setTabList,
  [TYPES.SET_ALLOWED_TAB_LIST]: setAllowedTabList,
  [TYPES.CLEAR_TAB_LIST]: clearTabList,
  [TYPES.CLEAR_ALLOWED_TAB_LIST]:clearAllowedTabList,
  [TYPES.SET_SELECTED_MODULE_PERMISSION]:setSelectedModulePermission,
  [TYPES.CLEAR_SELECTED_MODULE_PERMISSION]:clearSelectedModulePermission
});
